import { render, staticRenderFns } from "./ProductsCell.vue?vue&type=template&id=78310830&scoped=true"
import script from "./ProductsCell.vue?vue&type=script&lang=js"
export * from "./ProductsCell.vue?vue&type=script&lang=js"
import style0 from "./ProductsCell.vue?vue&type=style&index=0&id=78310830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78310830",
  null
  
)

export default component.exports